// Central mock data for August Doors & Windows
// NOTE: All data here is mocked for the frontend-only build.

export const brand = {
  name: "August",
  sub: "Doors & Windows",
  logo: "/assets/logo.jpg",
  phone: "+91 77658 62540",
  phoneHref: "tel:+917765862540",
  whatsapp: "https://wa.me/917765862540",
  address:
    "1st Floor, Krishna Ply Building, Near Kankali Mandir, Rambagh, Darbhanga, Bihar",
  mapUrl: "https://maps.app.goo.gl/2xVoSDofE65eqAXS6",
  tagline: "Designed for beauty. Built for strength. Engineered for security.",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Projects", to: "/#projects" },
  { label: "Contact", to: "/contact" },
];

export const hero = {
  kicker: "Premium Doors & Windows for Modern Living",
  titleTop: "Beautiful Spaces.",
  titleBottom: "Stronger Protection.",
  subtitle:
    "Designed for beauty. Built for strength. Engineered for security.",
  image:
    "https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=1600&auto=format&fit=crop",
};

export const marquee = [
  "Manufacture",
  "Supply",
  "Install",
  "Aluminium",
  "uPVC",
  "Sliding & Folding",
  "Designed for Beauty",
  "Built for Strength",
];

export const products = [
  {
    id: 1,
    tag: "01",
    title: "Aluminium Windows",
    points: ["Modern profiles", "Durability", "Elegant finish"],
    config: "Casement · Sliding · Fixed · Combination",
    desc:
      "Slim sightlines with structural strength — powder-coated aluminium profiles that are weather-resistant, corrosion-proof and engineered to disappear into your architecture.",
    image:
      "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?q=80&w=1600&auto=format&fit=crop",
  },
  {
    id: 2,
    tag: "02",
    title: "uPVC Windows",
    points: ["Energy efficiency", "Sound insulation", "Low maintenance"],
    config: "Casement · Sliding · Tilt & Turn · TwinSash · Louvre",
    desc:
      "Multi-chambered uPVC profiles — from classic casement to European Tilt & Turn — with high-performance sealing that keeps heat, dust, rain and noise outside, and comfort in.",
    image:
      "https://images.unsplash.com/photo-1628745423051-2cf1d836ccfb?q=80&w=1600&auto=format&fit=crop",
  },
  {
    id: 3,
    tag: "03",
    title: "Premium Doors",
    points: ["Strength", "Security", "Contemporary design"],
    config: "French · Balcony · Casement · Low Threshold",
    desc:
      "Statement entrances and balcony doors in single, double and French formats — multi-point locking, full-perimeter sealing and finishes that age beautifully.",
    image:
      "https://images.unsplash.com/photo-1702724758750-9ff8d50f02e5?q=80&w=1600&auto=format&fit=crop",
  },
  {
    id: 4,
    tag: "04",
    title: "Sliding & Folding Systems",
    points: ["Large openings", "Smooth operation", "Modern architecture"],
    config: "Lift & Slide · Fold N Slide · Tilt & Slide · 2–7 Panels",
    desc:
      "Floor-to-ceiling openings of up to seven panels that glide on precision hardware — maximising light and views while merging indoors with outdoors.",
    image:
      "https://images.unsplash.com/photo-1721902024148-287438cf3e05?q=80&w=1600&auto=format&fit=crop",
  },
];

export const manifesto = {
  eyebrow: "02 — The Manifesto",
  title: "Windows aren’t just openings. They’re part of your architecture.",
  desc:
    "A frame decides how light enters a room, how a facade reads from the street, and how safe a family feels at night. We treat every opening with that weight.",
  image:
    "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600&auto=format&fit=crop",
  items: [
    {
      no: "01",
      title: "Design",
      text:
        "Profiles proportioned to the building, not the catalogue. Every frame is drawn to disappear into the architecture.",
    },
    {
      no: "02",
      title: "Engineering",
      text:
        "Wind-load tested systems, precision hardware and glazing specified for the Indian climate.",
    },
    {
      no: "03",
      title: "Craft",
      text:
        "Measured, manufactured and installed by one team — so the detail drawn is the detail delivered.",
    },
  ],
};

export const whyUs = [
  {
    no: "01",
    title: "Beauty",
    text: "Contemporary designs that elevate your property — inside and out.",
    icon: "Sparkles",
  },
  {
    no: "02",
    title: "Strength",
    text: "Engineered systems built for long-term performance in real conditions.",
    icon: "ShieldCheck",
  },
  {
    no: "03",
    title: "Security",
    text: "Multi-point locking and toughened glazing that protect what matters.",
    icon: "Lock",
  },
  {
    no: "04",
    title: "Professional Installation",
    text:
      "From measurement to installation, handled professionally by our own team.",
    icon: "Wrench",
  },
];

export const projects = [
  {
    title: "uPVC Entrance Door",
    tag: "Residential · Door",
    image: "/assets/proj1.jpeg",
  },
  {
    title: "Arched Sliding Window",
    tag: "Residential · Window",
    image: "/assets/proj2.jpeg",
  },
  {
    title: "uPVC Bathroom Door",
    tag: "Interior · Door",
    image: "/assets/proj3.jpeg",
  },
  {
    title: "Arched Sliding System",
    tag: "Residential · Window",
    image: "/assets/proj4.jpeg",
  },
];

export const testimonials = [
  {
    quote:
      "Got uPVC windows installed for our new home. The sound insulation is remarkable — the street noise simply disappeared. Professional team, clean installation.",
    name: "Rakesh Kumar",
    place: "Darbhanga",
  },
  {
    quote:
      "The sliding doors they fitted in our living room open up the entire wall to the garden. Smooth operation even after months of daily use. Highly recommended.",
    name: "Priya Jha",
    place: "Rambagh, Darbhanga",
  },
  {
    quote:
      "From measurement to installation, everything was handled on time. The aluminium windows look premium and the finish is excellent. Worth every rupee.",
    name: "Amit Singh",
    place: "Laheriasarai, Darbhanga",
  },
];

// ------- ABOUT PAGE CONTENT -------
export const about = {
  intro:
    "August Fenestration is a contemporary architectural solutions company focused on creating sophisticated, functional, and high-performance fenestration systems for modern spaces. We believe that windows and doors are not merely structural components of a building; they play an essential role in defining its character, comfort, aesthetics, and connection with the surrounding environment.",
  paragraphs: [
    "Our approach combines thoughtful design, quality craftsmanship, modern technology, and a strong understanding of architectural requirements. Every project is approached with attention to detail, ensuring that the final solution complements the design language of the space while delivering the performance expected from a contemporary fenestration system.",
    "At August Fenestration, we understand that every building is different. Residential spaces, commercial establishments, hospitality projects, and architectural developments each demand their own balance of aesthetics, functionality, durability, light, ventilation, insulation, and security. Our solutions are therefore developed with a focus on the specific needs of each project rather than following a one-size-fits-all approach.",
  ],
  philosophy: {
    title: "Our Philosophy",
    paragraphs: [
      "We strive to create fenestration solutions that make spaces more refined, comfortable, and purposeful. From clean contemporary profiles to carefully considered configurations, we focus on achieving a seamless harmony between architecture and functionality.",
      "Quality is central to everything we do. We believe that a well-designed fenestration system should not only enhance the appearance of a building but should also provide dependable performance over time. This philosophy guides our choice of materials, design processes, manufacturing standards, and attention to installation and finishing.",
    ],
  },
  commitment: {
    title: "Our Commitment",
    paragraphs: [
      "Our commitment extends beyond delivering a product. We aim to build lasting relationships with architects, designers, builders, developers, and homeowners by providing dependable solutions and professional support throughout the project journey.",
      "With a vision for modern architecture and an appreciation for timeless design, August Fenestration continues to explore better ways to bring light, openness, elegance, and performance into the built environment.",
    ],
  },
  signature:
    "August Fenestration — Shaping spaces through thoughtful design, precision, and performance.",
};

export const vision = {
  title: "Our Vision",
  paragraphs: [
    "At August Fenestration, our vision is to become a trusted name in the fenestration and architectural solutions industry by setting higher standards in design, quality, innovation, and customer experience.",
    "We envision a future where windows and doors are not treated simply as functional elements of a building, but as an integral part of architectural expression. Our aim is to contribute to spaces that are visually refined, naturally illuminated, comfortable, secure, energy-conscious, and built to perform for years to come.",
    "We aspire to work alongside architects, designers, developers, builders, and homeowners to transform architectural concepts into thoughtfully engineered fenestration solutions. By continuously embracing evolving technologies, contemporary design trends, and improved materials and processes, we seek to create solutions that remain relevant to the changing demands of modern architecture.",
    "Our long-term vision is to build a brand recognized for design excellence, dependable performance, precision, and integrity—while creating lasting value for every project and every customer we serve.",
  ],
};

export const mission = {
  title: "Our Mission",
  paragraphs: [
    "Our mission at August Fenestration is to deliver high-quality fenestration solutions that bring together aesthetic appeal, functional performance, durability, and innovation.",
    "We are committed to understanding the unique requirements of every project and developing solutions that complement its architectural character while meeting practical expectations. From design and material selection to manufacturing, finishing, and installation, we believe every stage deserves careful attention and professional execution.",
    "We continuously work towards improving our products, processes, and expertise so that our customers receive solutions that are reliable, efficient, and designed for long-term performance. We place strong emphasis on quality control, precision, attention to detail, and consistent service because we believe that excellence is built through every small decision.",
    "Our mission also extends to creating meaningful and transparent relationships with our clients and professional partners. We aim to provide not just products, but dependable support and a smooth experience throughout every stage of a project.",
    "Above all, August Fenestration is committed to contributing to better-built environments by creating fenestration solutions that enhance the way people experience their spaces—bringing together light, design, comfort, security, and lasting performance.",
  ],
};

// ------- PRODUCTS PAGE CONTENT -------
export const productsPage = {
  intro:
    "At August Fenestration, our uPVC window and door systems are designed to bring together contemporary aesthetics, practical functionality, and dependable performance. With a versatile range of opening configurations, our systems can be adapted to different architectural styles, room requirements, and project dimensions.",
  intro2:
    "From compact residential openings to expansive architectural elevations, our range offers multiple configurations that provide flexibility in design while maintaining a clean and sophisticated appearance.",
  windowSystems: {
    title: "Window Systems",
    lead:
      "Our uPVC window collection includes a variety of configurations designed for different ventilation, accessibility, and aesthetic requirements:",
    items: [
      {
        name: "Casement Windows",
        text:
          "Single and double-opening configurations for efficient ventilation and everyday functionality.",
      },
      {
        name: "Tilt & Turn Windows",
        text:
          "Flexible opening options combining ventilation with convenient inward access.",
      },
      {
        name: "Sliding Windows",
        text:
          "Smooth horizontal operation, ideal where space efficiency and wider openings are important.",
      },
      {
        name: "Sliding & Fixed Windows",
        text:
          "A combination of operable and fixed panels for larger glazed areas and balanced visual design.",
      },
      {
        name: "Top-Hung Windows",
        text:
          "A practical configuration offering controlled ventilation with a contemporary profile.",
      },
      {
        name: "Louvre Window Systems",
        text:
          "Designed to encourage airflow while maintaining a distinctive architectural appearance.",
      },
      {
        name: "Combination Windows",
        text:
          "Custom combinations of fixed and operable sections to suit individual design requirements.",
      },
      {
        name: "Mesh & Grille Options",
        text:
          "Additional configurations for projects requiring enhanced practicality and ventilation solutions.",
      },
    ],
  },
  doorSystems: {
    title: "Door Systems",
    lead:
      "August Fenestration also offers versatile uPVC door configurations designed to create wider access points while complementing the overall architecture.",
    items: [
      "Sliding Windows & Doors",
      "Sliding & Fold Doors",
      "Casement Doors",
      "Single- and Double-Opening Doors",
      "Multi-Panel Sliding Systems",
      "Top-Fixed Door Configurations",
      "Mesh-Integrated Options",
    ],
  },
  designedAround: {
    title: "Designed Around Your Space",
    paragraphs: [
      "Every architectural project has its own requirements. That is why our uPVC systems can be configured according to the size, layout, functionality, and visual character of the opening.",
      "Whether the objective is to maximise natural light, improve ventilation, create a seamless connection between indoor and outdoor spaces, or achieve a refined contemporary façade, August Fenestration provides the flexibility to develop a solution around the project.",
    ],
  },
};

// uPVC finishes. Images provided for a few; the rest use accurate colour swatches.
export const finishes = {
  intro:
    "The right finish can completely transform the character of a window or door. At August Fenestration, our uPVC systems are available in a carefully selected palette of contemporary and wood-inspired finishes, allowing fenestration to become an intentional part of the overall interior and exterior design.",
  woodTitle: "Wood-Inspired Finishes",
  woodLead:
    "For spaces that require the warmth and character of natural timber with the clean performance of modern uPVC, our wood-inspired finishes offer an elegant alternative.",
  wood: [
    {
      name: "Golden Oak",
      color: "#7a4425",
      image: "/assets/prod3.jpg",
      text:
        "A warm, inviting wood tone that complements both classic and contemporary architectural styles.",
    },
    {
      name: "Dark Oak",
      color: "#3a2415",
      text:
        "A deep and sophisticated finish suited to bold façades and interiors with a refined, premium character.",
    },
    {
      name: "Walnut",
      color: "#4a2f21",
      image: "/assets/prod2.jpg",
      text:
        "A rich, balanced tone that brings warmth and understated elegance to modern spaces.",
    },
    {
      name: "Mahogany",
      color: "#3a2019",
      image: "/assets/prod4.jpg",
      text:
        "A distinctive deep wood finish that adds character and a timeless architectural appeal.",
    },
    {
      name: "Rustic Oak",
      color: "#6b5033",
      text:
        "A textured, natural-inspired appearance designed for projects seeking a more organic and traditional visual expression.",
    },
  ],
  solidTitle: "Contemporary Solid Finishes",
  solid: [
    {
      name: "Black",
      color: "#141414",
      text:
        "Bold, minimal, and architectural. Black frames create strong visual definition and pair naturally with modern façades.",
    },
    {
      name: "Grey",
      color: "#7b7f85",
      text:
        "A versatile contemporary shade that works beautifully with neutral palettes, modern architecture, and understated interiors.",
    },
    {
      name: "White",
      color: "#f4f5f6",
      image: "/assets/prod1.jpg",
      light: true,
      text:
        "A clean, timeless finish that suits virtually any architectural style and keeps interiors bright and open.",
    },
  ],
};

export const quoteOptions = [
  "Aluminium Windows",
  "uPVC Windows",
  "Premium Doors",
  "Sliding & Folding Systems",
  "Full Project",
];
